// slide
import '@splidejs/splide/dist/css/splide.min.css';
// slide
const Splide = require('@splidejs/splide').default;
$(document).ready(function () {
    if ($("#modal-promocion").length) {
        $("#modal-promocion").modal("show");

        $("#cerrar-modal-promocion").click(function () {
            $("#modal-promocion").modal("hide");
        });
    }
});

if ($(".proyecto-casa #atributos-slide").length) {
    new Splide("#atributos-slide", {
        type: "loop",
        perPage: 3,
        perMove: 1,
        autoplay: true,
        arrows: false,
        pagination: true,
        breakpoints: {
            992: {
                perPage: 2,
            },
            768: {
                perPage: 1,
            },
        },
    }).mount();
}

if ($(".proyecto-casa #items-galeria-slide").length) {
    new Splide("#items-galeria-slide", {
        type: "loop",
        perPage: 1,
        perMove: 1,
        autoplay: true,
        arrows: true,
        pagination: false,
    }).mount();
}
